<template>
  <div class="basic_wrap">
    <div class="red_top_bg">
      <div class="big_tit">
        {{ $t('income.basicin') }}
      </div>
    </div>
	
    <!-- 	<div class="main_title">
	    <div class="ft28 title c-white">{{$t('trading.balance')}}</div>
	    <div class="c-white ft48 font-bold">
	        {{acc?acc.money:'0.00'}}
	        <span class="ft28 ml20">{{utils_moneyMark()}}</span>
	    </div>
	    <div>
			<img src="../images/trading/homeicon.png" >
	    </div>
	</div> -->
    <div class="work_content">
      <div
        v-if="vip"
        class="main_work_title bglight"
      >
        <div class="card-name">
          {{ $t('vip2.level') }}：{{ vip.name }}
        </div>
        <!-- <div class="h2">{{$t('trading.everyday')}}：<em>{{vip.rate}} % </em></div> -->
        <div class="card">
          <div class="working">
            <div class="quan">
              <div class="vip">
                {{ vip.name }} 
              </div>
              <div class="rate">
                +<strong>{{ vip.rate }}</strong>%
              </div>
              <div class="step">
                <span
                  class="do"
                  :class="step>0?'bgdo':''"
                />
                <span
                  class="do"
                  :class="step>1?'bgdo':''"
                />
                <span
                  class="do"
                  :class="step>2?'bgdo':''"
                />
                <span
                  class="do"
                  :class="step>3?'bgdo':''"
                />
                <span
                  class="do"
                  :class="step>4?'bgdo':''"
                />
              </div>
            </div>
            <div class="gun" />
          </div>
        </div>
        <div class="title">
          {{ $t('trading.working') }}
        </div>
        <div class="flex-wrap flex-center">
          <div class="left">
            <b>{{ $t('income.lingt') }}</b>
            <em>{{ $t('income.lingti') }}</em>
            <!-- <em>最低收益需至少存款<i class="text-primary">5.00 助力</i></em> -->
          </div>
          <div class="right">
            <div
              class="basic_btn btn  "
              @click="$router.push('/invest2')"
            >
              {{ $t('income.paynow') }}
            </div>
          </div>
        </div>
      </div>
      <div class="main_work bgdeep">
        <div class="title flex alcenter flex-between">
          <div class="fl">
            <div class="ft36 c_191919 font-bold">
              {{ $t('trading.profit') }}
            </div>
          </div>
          <router-link to="/moneybag">
            <div class="flex-center view-all">
              <div>{{ $t('trading.all') }}</div>
              <span>
                <img
                  src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAhCAMAAAAMPGBYAAAAAXNSR0IArs4c6QAAAXpQTFRFAAAAAAAAAAD/////gICAqqqqgIC/mZmZqqqqkpKSn5+fv7+/jo6qqqqqmZmZoqKikpKkmZmZmZmqj4+fn5+flpalnJyqmZmmm5uml5ehkpKklZWnmZmhl5enm5uilpalmZmgmZmomJillJShnJyimJiompqklpaklZWjl5ekmZmhmJigmJikmJijl5eilpajlpajmpqjlpailpail5ejlpakl5eil5eimJilmZmjlpakmJijlZWjmJijmJiimJiil5ejlZWhlpakmJiilpakl5eil5eil5eilpajlpajl5eimJijl5ejlpajlpail5ejlpajl5eilpajl5ejlpahlpajlpajlpailpailpail5eilpailpajl5eilpajlpail5eilpailpahlpahlpajl5ejlpailpajlpajl5ehlpajlpailpajlpailpajlpailpajlpahlpail5eilpailpailpajlpail5eil5ejlpahlpailpailpaiGABniQAAAH10Uk5TAAEBAQIDBAUGBwgICQkKCw4PDxAQERIUFxscHR4gISIjIyUmLC81ODo7PD5DRUdLUFNVWltcXWBjZm1vdHd8fn+AgYGDhIeJi42ao6msra6xs7S1trbIys7R0tTV1djc3N3f4uXo6e7w8PHy8/T09fb4+Pn6+/v8/Pz9/f5vis/sAAABB0lEQVQYGV3BZSNsUQCG0ZdjdDOakVdd3d3tqpFXd42Og/H8dx/33tZSXNN8vn5p3CFcJdcC+KvFchRufcNGqhx/NoFwhWwxNdsQXSmTo+g/fIc9OWq3gfUS2WLr9oDlkBzl+/C+kiJH3S4QLpDN+3sELIVk86oP4HUpW476Q2AtUzav5QT4Vyqb13AML4v5cvQD0U5ZUnsfIDKWLiN5IALR0VxZeq4gOpgoI7EtAnfjSTKS++7hayooI677Aj6GMmQEmm/hcSIgI6nrBj6ngzICHWfgD2fJiGm8hrdRWRJaL+F1NkdGoP0U/MmgLA3n4I/Ey7bo8zSXKUfp2vNMnlyxlR1pcv0AgJdH6WBftxEAAAAASUVORK5CYII="
                  draggable="true"
                >
              </span>
            </div>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Fetch from '../../utils/fetch';
import Vue from 'vue';
import {Tab, Tabs, Progress, Empty, Dialog, Field} from 'vant';

Vue.use(Tab).use(Tabs).use(Progress).use(Empty).use(Dialog).use(Field);
export default {
  name: "Trading",
	data() {
		return {
			lang: this.$i18n.locale || "en_us",
			tabs: [
			{name:0,title:this.$t('item.all')}
			],
			active: 0,
			acc:null,
			vip:null,
			timeoutId:null,
			step:0,
			list: []
		}
	},
	created() {
		this.$parent.footer('trading');
	},
	mounted() {
		this.accinfo();
		this.start();
		this.timeoutId = setTimeout(this.dostep, 1000);
	},
	beforeDestroy() {
	  clearTimeout(this.timeoutId);
	},
	methods: {
		dostep(){
			this.step ++ ;
			if(this.step>5){
				this.step=1;
			}
			this.timeoutId = setTimeout(this.dostep, 1000);
		},
		dateFormat(fmt, time) {
			var date = new Date(time*1000);
			var year = date.getFullYear();
			var month = ("0" + (date.getMonth() + 1)).slice(-2);
			var day = ("0" + date.getDate()).slice(-2);
			var hours = ("0" + date.getHours()).slice(-2);
			var minutes = ("0" + date.getMinutes()).slice(-2);
			var seconds = ("0" + date.getSeconds()).slice(-2);
			
			var formattedDate = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
			return formattedDate
		},
		receive(id){
		  Fetch('/user/trading_receive', {
			id: id
		  }).then(r => {
			  this.$toast({
				  background: "#07c160",
				  message: this.$t('trading.receivesuc'),
			  });
			  this.list = r.data.list;
		  })
		},
		start() {
			Fetch('/user/item_trading').then(r => {
			  this.list = r.data.list;
			})
		},
		accinfo() {
			Fetch('/user/basicinfo').then((r) => {
				this.acc = r.data;
				this.vip = r.data.vip;
			});
		}
  }
}
</script>

<style lang="less" scoped>
/deep/ .van-cell {
  padding: 15px 26px;
}
.btn{
    width: 62px;
    height: 24px;
    border-radius: 5px;
    font-size: 9px;
    color: #fff;
    margin-right: 8px;
    line-height: 24px;
}
.red_top_bg {

}

.basic_wrap {
  position: relative;
}

.item_wrap {
  width: 100%;
  padding: 44px 0 0 0;

  .tabs {
    position: fixed;
    z-index: 100;
    width: 100%;

    max-width: 750px;
  }
}

.item_margin {
  margin-top: 54px !important;
}
.work_content{
    padding-bottom: 26px;
    overflow: hidden;
	.main_work_title{
	    margin: 2vw;
		padding: 20px;
		border-radius: 10px;
	    text-align: center;
		position: relative;
		.h2{
			font-size: 14px;
			margin-top: 20px;
			em{
				color: #FFFFFd;
				font-size: 16px;
			}
		}
		span{
		    display: block;
		    margin: 0 auto 18px;
			img{
				width: 100%;
			}
		}
		.title{
		    text-align: center;
		    font-size: 20px;
		    font-weight: 700;
			color: #0063d2;
		}
	}
	.main_work{
	    overflow: hidden;
	    padding: 5vw;
	    box-sizing: border-box;
		border-radius: 10px;
		margin: 2vw;
		.title{
		    margin-bottom: 20px;
		    box-sizing: border-box;
		}
		.view-all{
		    color: #282828;
		    font-size: 14px;
			span{
			    width: 6px;
			    height: 11px;
			    margin-left: 7px;
				img{
					width: 6px;
					height: 11px;
				}
			}
		}
		.list{
		    margin-top: 10px;
			.lidiv{
			    height: 71px;
			    position: relative;
			    margin-bottom: 15px;
			    border-radius: 15px;
			    box-sizing: border-box;
				.icon {
					span:nth-child(1){
					    height: 55px;
						img{
							height: 55px;
						}
					}
					.grow{
					    margin-left: 15px;
						.price{
						    font-size: 19px;
						    font-weight: 700;
						    display: flex;
						    align-items: flex-end;
							div{
							    font-size: 11px;
							    margin-left: 5px;
							    margin-bottom: 2px;
							}
						}
						.des{
						    font-size: 10px;
						    margin-top: 10px;
						    line-height: 15px;
						}
					}
				}
				.btn{
				    width: 65px;
				    height: 24px;
				    border-radius: 5px;
				    font-size: 9px;
				    color: #fff;
					margin-right:3vw;
					line-height: 24px;
				}
				.btn.disabled{
				    opacity: .65;
				}
			}
			.lidiv:nth-child(odd) {
			    // background: linear-gradient(to right bottom, #19857b 0%, #20615b 100%);
				background: #1f242b;
				color: #727d91;
			}
			
		}
		
	}
}
.alcenter {
    align-items: center;
}
.flex {
    display: flex;
}
.font-bold {
    font-weight: 700;
}
.ft36 {
    font-size: 18px;
}

.flex-between {
    display: flex;
    justify-content: space-between!important;
}
.flex-center {
    display: flex;
    justify-content: center;
    align-items: center;
}
.main_title{
    position: relative;
    width: 100%;
    height: 203px;
    background-size: 100% 100%;
    padding: 62px 0 0 48px;
    box-sizing: border-box;
	.title{
	    color: #fff;
	    margin-bottom: 15px;
	}
	div:nth-child(3){
	    position: absolute;
	    top: 41px;
	    right: 12px;
	    width: 142px;
	    height: 126px;
		img{
			width: 100%;
			height: 100%;
		}
	}
	
}
.ft28 {
	font-size: 14px;
}
.font-bold {
    font-weight: 700;
}
.ft48 {
    font-size: 24px;
}
.ml20 {
    margin-left: 10px;
}
.c-white {
    color: #fff;
}
.flex-wrap.flex-center{
    justify-content: space-between;
	margin-top: 20px;
	.left b {
        display: block;
        font-size: 16px;
        font-weight: 400;
    	text-align: left;
		margin-bottom: 10px;
    }
    .left em {
        display: block;
        margin-top: 5px;
        font-size: 12px;
        font-style: normal;
    	text-align: left;
        color: #ababab;
    }
}
.card-name {
	position: absolute;
	top: 0;
	left: 0;
	padding: 5px 15px;
	background-color: #0063d2;
	border-radius: 10px 0 5px 0;
	color: #282828;
	font-size: 14px;
}
.card{
	.working{
		width: 180px;
		height: 200px;
		margin: 10px auto;
		position: relative;
		margin-top: 3vh;
		.quan{
			background-color: #FFF;
			border-radius: 9999px;
			justify-content: center;
			align-content: center;
			flex-wrap: wrap;
			display: flex;
			width: 140px;
			align-items: center;
			height: 140px;
			position: absolute;
			left: 20px;
			top: 20px;
			z-index: 2;
			.vip{
				font-size: 3.5vw;
				line-height: 5vw;
				padding: 4px 16px;
				background-color: #20615B;
				border-radius: 9999px;
				color: #FFFFFd;
			}
			.rate{
				font-size: 3.5vw;
				line-height: 5vw;
				text-align: center;
				justify-content: center;
				align-items: center;
				display: flex;
				width: 100%;
				margin-top: 5px;
				color: #000;
				strong{
					font-size: 3.5vw;
					line-height: 5vw;
					padding: 1vw;
					color:rgb(248, 113, 113);
				}
			}
			.step{
				justify-content: center;
				align-items: center;
				display: flex;
				width: 100%;
				margin-top: 5px;
				.do{
					height: 5px;
					margin: 0 2px;
					border-radius: 3vw;
					width: 12px;
					transition-property: all;
					transition-duration: .15s;
					transition-timing-function: cubic-bezier(.4,0,1,1);
				}
				.bgdo {
				    background-color: #0063d2;
				}
			}
		}
		
		@keyframes spin {
		    0% {
		        transform: rotate(0)
		    }
		
		    to {
		        transform: rotate(360deg)
		    }
		}
		.gun{
			width: 180px;
			height: 180px;
			position: absolute;
			border-radius: 9999px;
			box-shadow: rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0.1) 0px 1px 3px 0px, rgba(0, 0, 0, 0.1) 0px 1px 2px -1px;
			background: linear-gradient(220.55deg, #51e4ee 0%, #3793FF 100%);
			animation: spin 1s linear infinite;
		}
	}
}
.lidiv {
	.icon{
		padding: 3vw;
	}
}

/* Scoped income dashboard styling. */
.basic_wrap { min-height: 100vh; padding-bottom: calc(86px + env(safe-area-inset-bottom)); background: linear-gradient(160deg, #25100c, #120907 57%, #1c0b09); color: #f5dfbd; }
.red_top_bg { background: rgba(27, 16, 13, .97); border-bottom: 1px solid rgba(185, 135, 59, .36); }
.red_top_bg .big_tit { color: #efc97f; }
.work_content { padding: 14px 0 calc(20px + env(safe-area-inset-bottom)); }
.work_content .main_work_title, .work_content .main_work { border: 1px solid rgba(185, 135, 59, .44); border-radius: 17px; background: linear-gradient(145deg, #2b1610, #180d0a) !important; box-shadow: 0 13px 30px rgba(0, 0, 0, .24); }
.card-name { border-bottom: 1px solid rgba(246, 210, 139, .48); border-right: 1px solid rgba(246, 210, 139, .48); background: linear-gradient(105deg, #6e0c0c, #9c2c17); color: #ffe2a7; }
.work_content .main_work_title .title, .work_content .main_work .title, .c_191919 { color: #f1ca80 !important; }
.left b { color: #f5dfbd; }.left em { color: #c5a887; }
.basic_btn.btn { border: 1px solid rgba(246, 210, 139, .64); background: linear-gradient(105deg, #710b0c, #a93219); color: #ffe8b7; box-shadow: 0 6px 16px rgba(70, 7, 5, .28); }
.card .working .quan { border: 1px solid rgba(230, 182, 105, .66); background: #1c100d; box-shadow: inset 0 0 20px rgba(185, 135, 59, .12); }
.card .working .quan .vip { background: #6f100d; color: #ffe4ad; }.card .working .quan .rate { color: #f5dfbd; }.card .working .quan .rate strong { color: #efc16d; }.card .working .quan .step .do { background: rgba(185, 135, 59, .26); }.card .working .quan .step .bgdo { background: #e6b669; }.card .working .gun { background: conic-gradient(from 0deg, #5d100d, #d09a46, #43100c, #5d100d); box-shadow: 0 0 24px rgba(185, 135, 59, .16); }
.view-all { color: #d8ba8c; }
</style>
